var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { InlineChildren, Text, Stack, Icon } from '@doordash/design-language';
import Button from '@doordash/component-button';
import Tooltip from '@doordash/component-tooltip';
import Banner from '@doordash/component-banner';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import CreateBudgetModal from './modals/create_budget_modal';
import { INITIAL_FETCH_STATUS } from '../../constants/fetch_status';
import * as React from 'react';
import { AdminPageSubpageContentContainer, SubpageContentHeaderSecondaryButtonContainer, } from '../AdminPage/AdminPageStyles';
import AdminBudgetsList from './admin_budgets_list';
import { useTeamAccountConfigurationContext } from '../TeamAccountPlanDetails/TeamAccountConfigurationContext';
import track from '../../utils/track';
import { BudgetsPageTestId } from '../testId';
import BudgetStrings from './BudgetStrings';
import ContactSalesModal from './modals/ContactSalesModal';
import { CONTACT_SALES_URL, PORTAL_ROUTE_PREFIX } from '../../constants/values';
import PaymentStrings from '../Billing/PaymentCard/PaymentStrings';
import { useShouldOperationSetOnboardingStep } from '../SelfServe/Onboarding/useSetOnboardingStepMutation';
import { OnboardingStep } from '../../types/GloblalTypes';
import { getSelectedTeamAccountPaymentInfo } from '../../selectors/teamAccountPaymentInfoSelector';
import { TEAM_ACCOUNT_PAYMENT_METHOD, } from '../../types/portal_data';
import { MealBudgetsEvents } from '../../constants/events';
import { SendEmailNotificationsModal } from './modals/SendEmailNotificationsModal';
import { DV2_NAMES, dv2Defaults } from '../DV2';
import { useDVSBoolean } from '@doordash/lib-dvs-client/lib/react';
import { fetchTeamAccountBudgets } from './budgets_slice';
import { getSelectedTeamAccountContent } from '../../selectors/uiSelector';
export var AdminBudgets = function (_a) {
    var _b;
    var teamAccountId = _a.teamAccountId, _c = _a.budgets, budgets = _c === void 0 ? [] : _c, _d = _a.fetchStatus, fetchStatus = _d === void 0 ? INITIAL_FETCH_STATUS : _d;
    var isBudgetReminderEnabled = useDVSBoolean(DV2_NAMES.ddfwBudgetReminder, dv2Defaults.ddfwBudgetReminder);
    var dispatch = useDispatch();
    var history = useHistory();
    var _e = __read(React.useState(false), 2), isBudgetModalOpen = _e[0], setIsBudgetModalOpen = _e[1];
    var _f = __read(React.useState(false), 2), isBudgetEmailNotificationsModalOpen = _f[0], setIsBudgetEmailNotificationsModalOpen = _f[1];
    var _g = __read(React.useState(false), 2), shoulRefetchBudgetList = _g[0], setshoulRefetchBudgetList = _g[1];
    var _h = __read(React.useState({
        id: '',
        hasGroup: false,
    }), 2), selectedBudgetInfo = _h[0], setSelectedBudgetInfo = _h[1];
    var _j = __read(React.useState(null), 2), budgetReminderEntryPoint = _j[0], setBudgetReminderEntryPoint = _j[1];
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    var teamAccountName = (teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.name) || '';
    var selectedTeamAccountPaymentInfo = useSelector(getSelectedTeamAccountPaymentInfo);
    var paymentMethod = (_b = selectedTeamAccountPaymentInfo === null || selectedTeamAccountPaymentInfo === void 0 ? void 0 : selectedTeamAccountPaymentInfo.paymentMethod) !== null && _b !== void 0 ? _b : TEAM_ACCOUNT_PAYMENT_METHOD.UNKNOWN;
    var _k = useTeamAccountConfigurationContext(), hasMaxBudgetAmountLimit = _k.hasMaxBudgetAmountLimit, maxBudgetAmountLimit = _k.maxBudgetAmountLimit, hasMaxBudgetsLimit = _k.hasMaxBudgetsLimit, maxBudgetsLimit = _k.maxBudgetsLimit;
    var hasCompletedBudgetOnboardingStep = !useShouldOperationSetOnboardingStep(teamAccountId, OnboardingStep.ONBOARDING_STEP_ADD_BUDGET);
    var hasCompletedPaymentOnboardingStep = !useShouldOperationSetOnboardingStep(teamAccountId, OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD);
    // for FTUX onboarding experience when Cx adds budget before adding payment method
    // we don't have access to payment methods in the budgets page, so we are purely going off of the
    // completed onboarding steps here
    var shouldShowPaymentAddWarningBanner = paymentMethod === TEAM_ACCOUNT_PAYMENT_METHOD.DEFAULT_CARD &&
        hasCompletedBudgetOnboardingStep &&
        !hasCompletedPaymentOnboardingStep;
    var shouldDisplayLimitSubtitle = hasMaxBudgetsLimit && budgets.length > 0;
    var hasReachedBudgetsLimit = hasMaxBudgetsLimit && budgets.length >= maxBudgetsLimit.limit;
    var confirmBudgetEmailSending = function (_a) {
        var budgetInfo = _a.budgetInfo, _b = _a.shouldRefetchBudgetListLater, shouldRefetchBudgetListLater = _b === void 0 ? false : _b, entryPoint = _a.entryPoint;
        setSelectedBudgetInfo(function (prevState) { return (__assign(__assign({}, prevState), { id: budgetInfo.id, hasGroup: budgetInfo.hasGroup })); });
        setBudgetReminderEntryPoint(entryPoint);
        setshoulRefetchBudgetList(shouldRefetchBudgetListLater);
        setIsBudgetEmailNotificationsModalOpen(true);
    };
    var closeEmailNotificationModal = function () {
        setIsBudgetEmailNotificationsModalOpen(false);
        if (shoulRefetchBudgetList) {
            dispatch(fetchTeamAccountBudgets({
                teamAccountId: teamAccountId,
                includeGroupsInfo: true,
            }));
        }
    };
    React.useEffect(function () {
        track(MealBudgetsEvents.VIEW_BUDGETS);
    }, []);
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(Stack, { size: Stack.Sizes.Small },
                React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                    React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "Meal Budgets"),
                    React.createElement(SubpageContentHeaderSecondaryButtonContainer, null,
                        React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: function () {
                                setIsBudgetModalOpen(true);
                                track(MealBudgetsEvents.CLICK_ADD_BUDGET);
                            }, "data-testid": BudgetsPageTestId.CreateBudgetButton }, "Create Budget")),
                    isBudgetModalOpen ? (hasReachedBudgetsLimit ? (React.createElement(ContactSalesModal, { maxBudgetLimit: maxBudgetsLimit.limit, onClose: function () { return setIsBudgetModalOpen(false); }, teamAccountId: teamAccountId })) : (React.createElement(CreateBudgetModal, { teamAccountId: teamAccountId, maxBudgetAmountLimit: hasMaxBudgetAmountLimit ? maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit : null, confirmBudgetEmailSending: confirmBudgetEmailSending, onClose: function () { return setIsBudgetModalOpen(false); } }))) : null,
                    isBudgetReminderEnabled && isBudgetEmailNotificationsModalOpen && (React.createElement(SendEmailNotificationsModal, { onClose: closeEmailNotificationModal, teamAccountName: teamAccountName, budgetInfo: selectedBudgetInfo, entryPoint: budgetReminderEntryPoint }))),
                React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexStart, alignItems: InlineChildren.Alignment.Center }, shouldDisplayLimitSubtitle && (React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexStart, alignItems: InlineChildren.Alignment.FlexStart, size: InlineChildren.Sizes.XxxSmall },
                    React.createElement(Text, { color: Text.Colors.TextTertiary }, BudgetStrings.budgetsLimitSubtitle(budgets.length, maxBudgetsLimit.limit)),
                    React.createElement(Tooltip, { interactionType: Tooltip.InteractionTypes.ToggleClick, content: React.createElement(React.Fragment, null,
                            "You've added ",
                            budgets.length,
                            " out of \u00A0",
                            maxBudgetsLimit.limit,
                            " meal budgets allowed by your Team plan. To add more budgets,",
                            ' ',
                            React.createElement(Button, { isInline: true, size: Button.Sizes.Small, type: Button.Types.Link, tag: "a", href: CONTACT_SALES_URL(teamAccountId), target: "_blank", rel: "noreferrer" },
                                React.createElement(Text, { styles: Text.Styles.Body2, textDecoration: Text.TextDecorations.Underline, color: Text.Colors.BannerInformationalIcon }, "contact sales")),
                            ' ',
                            "to upgrade to the Enterprise plan."), position: Tooltip.Positions.TopCenter, size: Tooltip.Sizes.Large }, function () { return (React.createElement(Icon, { size: Icon.Sizes.Medium, type: Icon.Types.InfoCircleLine, color: Icon.Colors.TextTertiary })); }))))),
            shouldShowPaymentAddWarningBanner && (React.createElement(Stack, { size: Stack.Sizes.Small },
                React.createElement(Banner, { label: "", body: PaymentStrings.paymentAddWarningBannerText(), primaryAction: {
                        content: PaymentStrings.paymentAddWarningBannerPrimaryButton(),
                        onClick: function () {
                            history.push(PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/billing");
                        },
                    }, variant: Banner.Variants.Warning, type: Banner.Types.Default })))),
        React.createElement(AdminBudgetsList, { teamAccountId: teamAccountId, budgets: budgets, fetchStatus: fetchStatus, maxBudgetAmountLimit: hasMaxBudgetAmountLimit ? maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit : null, confirmBudgetEmailSending: confirmBudgetEmailSending })));
};
export default AdminBudgets;
